export default __webpack_public_path__ + "static/media/avatar.3aaad4fe.jpeg";